import {Community, CommunityInitState} from '@/store/community/community.types';
import {CommunityAction} from '@/store/community/community.actions';
import {CommunityMutations} from '@/store/community/community.mutations';

const namespaced = true;

export const communityInitState: CommunityInitState = {
  community: [{}] as Community[],
  totalCommunity: 0
};

export const communityState = {
  namespaced,
  state: communityInitState,
  actions: CommunityAction,
  mutations: CommunityMutations,
  // getters
};
